// extracted by mini-css-extract-plugin
module.exports = {"UTiframeDimention":"styles_UTiframeDimention__1ExQU"};